import React from "react";
import Button from "b2b-ui-components-lib/lib/components/button";
import "./Success.scss";

const SuccessPage = () => {
  return (
    <div className="change_order_success">
      <div className="container">
        <div className="success_group">
          <div className="success_wrapper">
            <div className="success_section">
              <div className="success_block">
                <h2 className="order_success">
                  <span className="checkmark popup">
				  </span>
				  Your abc order has been
                  raised successfully
                </h2>
				<p className="confirmation_email">We've received your order request. One of our team members will contact you shortly with more details.</p>
				<p className="sms_message">
				Should you have any queries regarding cancellation or extension of service, write to us at <a href="mailto:enterprise.request@airtel.com" className="mail-url">enterprise.request@airtel.com</a> copying your Account Manager and Relationship Manager. At least 10 days before the due disconnection date.
								</p> 
								<div className="success_action">
               
                    <Button
                      displayName="Track Order"
                      onClick=""
                    />
					   <Button
                    displayName="Go Back To Connection"
                    variant="outlinebtn"
                    onClick=""
                  />
                </div>
				<div className="facing_section">
                    <div className="facing_problem">
                      Facing a problem?{" "}
                      <a
                        className="link"
                        href=""
                      >
                        Let us know
                      </a>
                    </div>
					<div className="facing_problem">
						Need to know more?{" "}
						<a className="link" href="">
						Get Help
						</a>
					</div>
                </div>
              </div>
			  <div className="grey_bg">
							<h3 className="detail_title">Request Details</h3>
							<ul className="connection_listing">
							<li>
							Number of Circuits
								<span>100</span>
							</li>
							<li>
								Order ID
								<span>231242984600</span>
							</li>
							<li>
								Date & time
								<span>
								10:29 am - 09 May 21
								</span>
							</li>
							<li>
								Request Type
								<span>New Order</span>
							</li>
							</ul>
						</div>
						
				
            </div>
			
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
